import React from 'react';
import { useSearchParams, useNavigate, Link } from 'react-router-dom';
import { CheckCircle2, AlertCircle, Info, ArrowRight } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card } from '@/components/ui/card';
import { ATLAS_LOGO_URL, ATLAS_NAME } from '@/lib/brand';

const ICON_BY_STATUS = {
  success: { Icon: CheckCircle2, color: 'text-emerald-600', bg: 'bg-emerald-50 border-emerald-200' },
  info:    { Icon: Info,         color: 'text-blue-600',    bg: 'bg-blue-50 border-blue-200' },
  error:   { Icon: AlertCircle,  color: 'text-red-600',     bg: 'bg-red-50 border-red-200' },
};

export default function AdminActionResultPage() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const status = params.get('status') || 'info';
  const message = params.get('message') || 'Action completed.';
  const { Icon, color, bg } = ICON_BY_STATUS[status] || ICON_BY_STATUS.info;

  return (
    <div className="min-h-screen bg-[#FDFBF7] flex items-center justify-center px-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-6">
          <Link to="/" className="inline-flex flex-col items-center gap-3" data-testid="action-result-brand">
            <div className="w-14 h-14 rounded-lg bg-white border border-[#EBE7E0] flex items-center justify-center overflow-hidden shadow-sm">
              <img src={ATLAS_LOGO_URL} alt="" className="w-full h-full object-contain" />
            </div>
            <div>
              <h1 className="font-serif-display text-2xl text-[#14213D] tracking-tight">{ATLAS_NAME}</h1>
              <p className="text-[11px] uppercase tracking-[0.18em] text-[#5A6577] mt-1">Admin action</p>
            </div>
          </Link>
        </div>

        <Card className="p-7 border border-[#EBE7E0]" data-testid="action-result-card">
          <div className={`w-14 h-14 mx-auto rounded-full border flex items-center justify-center mb-5 ${bg}`}>
            <Icon className={`h-7 w-7 ${color}`} />
          </div>
          <p className="text-base text-[#14213D] text-center leading-relaxed mb-6" data-testid="action-result-message">
            {message}
          </p>
          <Button
            onClick={() => navigate('/admin/users')}
            className="w-full bg-[#14213D] hover:bg-[#0F1A2E] text-[#FDFBF7]"
            data-testid="action-result-cta"
          >
            Open Admin Users <ArrowRight className="h-4 w-4 ml-2" />
          </Button>
        </Card>
      </div>
    </div>
  );
}
